import { Utils } from "helpers/utils";
import { APIClient } from "./apiCore";
import * as url from "./urls";
import { FrontEndApp } from "const";

const api = new APIClient();

const getProfileDetails = () => {
  return api.get(url.GET_PROFILE_DETAILS);
};

const getSettings = () => {
  return api.get(url.GET_USER_SETTINGS);
};

const loadThirdApiUrl = () => {
  return api.fnGet("/load-third-api-url");
}

const updateSettings = (field: string, value: any) => {
  return api.update(url.UPDATE_ETTINGS, {
    field: field,
    value: value,
  });
};

const updateFcmTokenAsync = async (token: string) => {
  // try {
    let body = JSON.stringify({
      EndPoint: token,
      P256DH: '',
      Auth: '',
      DeviceId: localStorage.getItem("did4") ?? "",
      AppName: process.env.REACT_APP_NAME,
      AppAbbr: process.env.REACT_APP_COMPANY_ABBR,
      frontEndApp: FrontEndApp.AppChat2S
    });
    //  console.log('updateFcmTokenAsync:', body);
    const response = await fetch(`${process.env.REACT_APP_APIURL}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
      },
      body: body,
      credentials:'include'
    });
    // console.log('updateFcmTokenAsync:', response);
    return response;
  // } catch (e) {
  //   console.error('updateFcmTokenAsync:', e);
  //   return null;
  // }
}

export { getProfileDetails, getSettings, updateSettings, updateFcmTokenAsync, loadThirdApiUrl };
